<template>
  <v-data-table
    :headers="[
      { value: 'datetime', text: 'Date', width: 100 },
      { value: 'time_diff', text: 'Difference', width: 100 },
      { value: 'url', text: 'Url' }
    ]"
    :items="hits"
    disable-pagination
    hide-default-footer
    hide-default-header
  >
    <template v-slot:body="{ items }">
      <tbody>
        <tr
          :class="{
            'is-paid-click': item.is_payed === true,
            'is-conversion-click': item.is_conversion === true,
            'is-banned-click': item.is_banned === true
          }"
          v-for="(item, key) in items"
          :key="key"
        >
          <td style="width: 100px">
            <DateTimeColumn :timestamp="item.datetime" />
          </td>
          <td style="width: 100px">
            <div class="history-date">
              {{ item.time_diff }}
            </div>
          </td>
          <td>
            <div style="margin: 1em 0">
              <div v-if="item.referer && item.referer.length > 0">
                <details v-if="item.referer.length > maxRefererLength">
                  <summary
                    ><span style="font-weight: bold">Referer</span>:
                    {{ cutReferer(item.referer) }}</summary
                  >
                  <a :href="item.referer" target="_blank">
                    {{ item.pretty_refer }}
                  </a>
                </details>
                <div v-else>
                  <span style="font-weight: bold">Referer</span>:
                  <a :href="item.referer" target="_blank">
                    {{ item.pretty_refer }}
                  </a>
                </div>
              </div>
              <div v-else>
                <span style="font-weight: bold">No referer</span>
              </div>
            </div>
            <div>↓</div>
            <div style="margin: 1em 0">
              <span style="font-weight: bold">URL</span>
              :
              <a :href="item.url" target="_blank">
                {{ item.pretty_url }}
              </a>
            </div>
            <div style="margin: 1em 0" v-if="item.clid">
              <span style="font-weight: bold">Clid</span>
              : {{ item.clid }}
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-data-table>
</template>

<script>
import DateTimeColumn from "@/components/_Tables/DateTimeColumn";

export default {
  name: "HitsTable.vue",
  components: {
    DateTimeColumn
  },
  props: {
    hits: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      maxRefererLength: 200
    };
  },
  methods: {
    cutReferer(value) {
      return value.substr(0, this.maxRefererLength) + "...";
    }
  }
};
</script>

<style scoped>
summary {
  list-style: none;
}
summary::-webkit-details-marker {
  display: none;
}
.is-paid-click {
  background-color: #e1e8ff;
  color: #0d47e7;
}
.is-conversion-click {
  background-color: #e1ffe2;
  color: #33691e;
}
.is-banned-click {
  color: crimson;
  background-color: #ffe1e1;
}
</style>
